import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { MojoMarkSearchPhraseModule } from 'mojo-mark-search-phrase';

import { JobLocationModule } from '@shared/job-location/job-location.module';

import { StatusModule } from '../status/status.module';
import { JobCardComponent } from './job-card.component';

@NgModule({
  declarations: [JobCardComponent],
  imports: [CommonModule, MojoFeatureExtensionsModule, StatusModule, MojoMarkSearchPhraseModule, JobLocationModule],
  exports: [JobCardComponent]
})
export class JobCardModule {}
